export default __webpack_public_path__ + "static/media/magon-outside.6cbb4185.jpg";